import { AgentChat } from "@/components/chat/AgentChat";

export default function CoverLetterTool() {
  return <AgentChat agent="cover_letter" />;
}
